import { Stack } from "@mantine/core";
import { IconArrowDown, IconArrowUp } from "@tabler/icons";
import { useContext } from "react";
import IdeasContext from "../IdeasContext";

export const SortArrow = ({ direction }: { direction?: "asc" | "desc" }) => {
  const { sortStatus } = useContext(IdeasContext);
  const resolvedDirection =
    direction ??
    sortStatus?.direction ??
    sortStatus?.directionStatus ??
    "asc";

  return (
    <Stack>
      {resolvedDirection === "asc" ? (
        <IconArrowUp
          size={14}
          strokeWidth={1.7}
          style={{ color: "rgba(10, 10, 10, 1)" }}
        />
        
      ) : (
        <IconArrowDown
          size={14}
          strokeWidth={1.7}
          style={{ color: "rgba(10, 10, 10, 1)" }}
        />
        
      )}
    </Stack>
  );
};


